import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { SidebarApp } from '~/sidebar/sidebarApp.enum';
import atb from '../../../../assets/images/templateThumbnails/atb.png';
import boundariesPlain from '../../../../assets/images/templateThumbnails/boundaries.png';
import boundariesDemographic from '../../../../assets/images/templateThumbnails/boundaries_demographic.png';
import boundariesFill from '../../../../assets/images/templateThumbnails/boundaries_fill.png';
import dtp from '../../../../assets/images/templateThumbnails/dtp.png';
import filter from '../../../../assets/images/templateThumbnails/filter.png';
import grouping from '../../../../assets/images/templateThumbnails/grouping.png';
import heatmaps from '../../../../assets/images/templateThumbnails/heatmaps.png';
import layering from '../../../../assets/images/templateThumbnails/layering.png';
import locationFind from '../../../../assets/images/templateThumbnails/location_find.png';
import poi from '../../../../assets/images/templateThumbnails/poi.png';
import radii from '../../../../assets/images/templateThumbnails/radii.png';
import routes from '../../../../assets/images/templateThumbnails/routes.png';
import skip from '../../../../assets/images/templateThumbnails/skip.png';
import styling from '../../../../assets/images/templateThumbnails/styling.png';
import territoryManual from '../../../../assets/images/templateThumbnails/territories_manual.png';

export enum MapTemplates {
  ATB = 'ATB',
  BoundariesDemographic = 'BoundariesDemographic',
  BoundariesFill = 'BoundariesFill',
  BoundariesPlain = 'BoundariesPlain',
  DTP = 'DTP',
  Filter = 'Filter',
  Grouping = 'Grouping',
  Heatmaps = 'Heatmaps',
  Layering = 'Layering',
  LocationFind = 'LocationFind',
  POI = 'POI',
  Radii = 'Radii',
  Routes = 'Routes',
  Skip = 'Skip',
  Styling = 'Styling',
  TerritoryManual = 'TerritoryManual',
}

export type TemplateToolOrApp = Readonly<
  | { mapTool: MapTool; sidebarApp?: never }
  | { sidebarApp: SidebarApp; mapTool?: never }
>;

const TEMPLATE_TO_TOOL_OR_APP: Partial<Record<MapTemplates, TemplateToolOrApp>> = {
  [MapTemplates.ATB]: { mapTool: MapTool.Boundary },
  [MapTemplates.BoundariesDemographic]: { mapTool: MapTool.Boundary },
  [MapTemplates.BoundariesFill]: { mapTool: MapTool.Boundary },
  [MapTemplates.BoundariesPlain]: { mapTool: MapTool.Boundary },
  [MapTemplates.DTP]: { mapTool: MapTool.Proximity },
  [MapTemplates.Filter]: { mapTool: MapTool.Filter },
  [MapTemplates.Grouping]: { mapTool: MapTool.Grouping },
  [MapTemplates.Heatmaps]: { mapTool: MapTool.HeatMap },
  [MapTemplates.Layering]: { mapTool: MapTool.Layering },
  [MapTemplates.POI]: { mapTool: MapTool.Places },
  [MapTemplates.Radii]: { mapTool: MapTool.Proximity },
  [MapTemplates.Routes]: { mapTool: MapTool.Routing },
  [MapTemplates.Styling]: { sidebarApp: SidebarApp.MapSettings },
  [MapTemplates.TerritoryManual]: { mapTool: MapTool.Boundary },
};

export const getTemplateToolOrApp = (template: MapTemplates): TemplateToolOrApp | undefined => TEMPLATE_TO_TOOL_OR_APP[template];

export const mapTemplates = [
  { url: skip, id: MapTemplates.Skip },
  { url: grouping, id: MapTemplates.Grouping },
  { url: radii, id: MapTemplates.Radii },
  { url: dtp, id: MapTemplates.DTP },
  { url: heatmaps, id: MapTemplates.Heatmaps },
  { url: boundariesPlain, id: MapTemplates.BoundariesPlain },
  { url: boundariesDemographic, id: MapTemplates.BoundariesDemographic },
  { url: boundariesFill, id: MapTemplates.BoundariesFill },
  { url: routes, id: MapTemplates.Routes },
  { url: territoryManual, id: MapTemplates.TerritoryManual },
  { url: atb, id: MapTemplates.ATB },
  { url: poi, id: MapTemplates.POI },
  { url: layering, id: MapTemplates.Layering },
  { url: styling, id: MapTemplates.Styling },
  { url: filter, id: MapTemplates.Filter },
  { url: locationFind, id: MapTemplates.LocationFind },
];
